import { render } from "./newOrganization.vue?vue&type=template&id=61e11890&scoped=true"
import script from "./newOrganization.vue?vue&type=script&lang=js"
export * from "./newOrganization.vue?vue&type=script&lang=js"

import "./newOrganization.vue?vue&type=style&index=0&id=61e11890&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e11890"]])

export default __exports__